// Round U — texts and the warning rule for one "Per functie" row. Pure helpers.
export const functieRowNeedsAttention = (row) => !row?.targeted_open || !row?.memos_30d;

export const functieRowTexts = (row) => {
  const k = row?.memos_30d || 0;
  const names = (row?.users || []).filter(Boolean);
  return {
    open: `${row?.targeted_open || 0} open van ${row?.targeted_total || 0}`,
    memos: `${k} ${k === 1 ? "memo" : "memo's"} in 30 dagen`,
    users: names.length ? names.join(", ") : "Nog niemand met deze functie",
  };
};

export const nudgeStatusText = (s) => {
  if (!s) return null;
  if (!s.enabled) return "overgeslagen: geen mailinstelling";
  if (!s.last_run_at) return "nog niet";
  return s.last_result;
};
